import React from 'react';
import PropTypes from 'prop-types';

const Group = ({ title, className, children }) => {
  return (
    <div className={`form-group ${className}`}>
      <h3>{title}</h3>
      <div>{children}</div>
    </div>
  );
};

export default Group;

Group.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Group.defaultProps = {
  className: '',
  title: '',
};
